import { useLocation } from 'react-router-dom';
import { supportedLngs } from '../i18n';

const baseUrl = 'https://illustroke.com';

export function AlternateLinks() {
  const location = useLocation();

  // Remove the language prefix from the path
  const path = location.pathname.replace(/^\/[a-z]{2}(\/|$)/, '/');

  return [
    ...supportedLngs.map(lng => ({
      rel: "alternate",
      hrefLang: lng,
      href: `${baseUrl}/${lng}${path}`
    })),
    {
      rel: "alternate",
      hrefLang: "x-default",
      href: `${baseUrl}/en${path}`
    },
    {
      rel: "canonical",
      href: `${baseUrl}${location.pathname}`
    }
  ];
}